import { Badge, type BadgeProps } from '@mantine/core';
import { VACANCY_STATUS_MODEL } from '../../constants';
import commonStyles from '../../vacancyStatus.module.scss';

type VacancyStatusSelectOptionProps = {
  status: string;
} & BadgeProps;

export const VacancyStatusSelectOption = ({
  status,
  ...props
}: VacancyStatusSelectOptionProps) => {
  switch (status) {
    case VACANCY_STATUS_MODEL.NEW:
      return (
        <Badge
          className={`${commonStyles.vacancyStatus} ${commonStyles.vacancyStatusSelectOption} ${commonStyles.vacancyStatusNew}`}
          size='md'
          {...props}
        >
          Новая
        </Badge>
      );
    case VACANCY_STATUS_MODEL.IN_PROGRESS:
      return (
        <Badge
          className={`${commonStyles.vacancyStatus} ${commonStyles.vacancyStatusSelectOption} ${commonStyles.vacancyStatusInProgress}`}
          size='md'
          {...props}
        >
          Идёт подбор
        </Badge>
      );
    case VACANCY_STATUS_MODEL.SELECTION_SUSPENDED:
      return (
        <Badge
          className={`${commonStyles.vacancyStatus} ${commonStyles.vacancyStatusSelectOption} ${commonStyles.vacancyStatusSuspended}`}
          size='md'
          {...props}
        >
          Подбор приостановлен
        </Badge>
      );
    case VACANCY_STATUS_MODEL.SELECTION_COMPLETED:
      return (
        <Badge
          className={`${commonStyles.vacancyStatus} ${commonStyles.vacancyStatusSelectOption} ${commonStyles.vacancyStatusCompleted}`}
          size='md'
          {...props}
        >
          Подбор выполнен
        </Badge>
      );
    case VACANCY_STATUS_MODEL.SELECTION_CANCELLED:
      return (
        <Badge
          className={`${commonStyles.vacancyStatus} ${commonStyles.vacancyStatusSelectOption} ${commonStyles.vacancyStatusCancelled}`}
          size='md'
          {...props}
        >
          Подбор отменен
        </Badge>
      );
    case VACANCY_STATUS_MODEL.ARCHIVED:
      return (
        <Badge
          className={`${commonStyles.vacancyStatus} ${commonStyles.vacancyStatusSelectOption} ${commonStyles.vacancyStatusArchived}`}
          size='md'
          {...props}
        >
          В архиве
        </Badge>
      );
    default:
      return null;
  }
};
